import * as React from 'react';
import { d3AverageChart } from '../../../interface/VendorReportInterface';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, Cell } from 'recharts'
import { numberWithCommas, numberWithDollarSign } from '../../Common/Helpers';


export class AnnualEarningsChart extends React.Component<d3AverageChart, {}> {
    render() {
        let the_width = (this.props.normal_or_large == 0) ? 580 : 900;
        let the_height = (this.props.normal_or_large == 0) ? 200 : 600;
        let scale = this.props.scale ? this.props.scale : 1;
        let the_margin = (this.props.normal_or_large == 0) ? { top: 0, right: 10, left: 80*scale, bottom: 0 } :
            { top: 15, right: 0, left: 75, bottom: 45 };

        let iconSize = (this.props.normal_or_large == 0) ? 14 : 24;
        let payload = [];
        let the_fontsize = (this.props.normal_or_large == 0) ? 13 : 15;

        let bardata = [];

        bardata.push({ name: "University Vendors", Earnings: this.props.selectedVendorProfile.university_wage_mean / 1000 });
        if (this.props.withNational) {
            bardata.push({ name: "National Average", Earnings: this.props.selectedVendorProfile.national_wage_mean / 1000 });
        }
        const fill = ["#c1d7d8", "#8884d8", "#82ca9d", "#5cbae6", "#b6d957", "#fac364", "#8cd3ff", "#d998cb", "#f2d249", "#93b9c6", "#ccc5a8", "#52bacc", "#dbdb46", "#98aafb"];

        return <div><h5>Annual Earnings</h5>
            <BarChart width={the_width*scale} height={the_height*scale} data={bardata}
                layout="vertical" margin={the_margin} >
                <Tooltip formatter={(value) => {
                    return numberWithDollarSign(value) + 'K';
                }}/>
                <XAxis type="number" dataKey="Earnings" tick={{ fontSize: the_fontsize }} tickFormatter={(tick) => ((tick) + 'K')} />
                <YAxis type="category" dataKey="name" tick={{ fontSize: the_fontsize }} />
                <CartesianGrid stroke="#f5f5f5" />
                <Bar barSize={40*scale} dataKey="Earnings" fill={fill[1]}></Bar>
            </BarChart>
            <div className="axis_label">Thousands of dollars</div>
        </div>

    }
}
